const getDividerClassNames = divider => {
  const {
    side,
    width = 1,
    color = 'light'
  } = divider;
  return `Box-divider--${color}-${side}-${width}`;
};

export default getDividerClassNames;